var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompressioneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 42.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.62822 21.871h22.812v7.1288h-22.812zm.71288 6.416h21.387v-5.7031h-21.387z",
    fill: "#008768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.4699 21.158h7.1288v-10.693h-7.1288z",
    fill: "#008768"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.71288 0 0 .71288 9.3687 21.158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v8.246",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.71288 0 0 .71288 14.699 21.158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v8.246",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompressioneIcon);
export default __webpack_public_path__ + "static/media/CompressioneIcon.3d8413289793f300a8c7d54c3f29b930.svg";
export { ForwardRef as ReactComponent };